<template>
  <div class="outsourcing">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">IT Outsourcing</h3>
        <p>창립 2011년 이래 최고의 IT 서비스를 공급하는 회사로서의 입지를 구축하고 있습니다.</p>
      </section>
      <section class="sub-body-content">
        
        <v-container fluid>
          <!-- PC -->
          <v-tabs class="d-none d-sm-block" grow v-model="tabs">
            <v-tab>애플리케이션</v-tab>
            <v-tab>보안/네트워크</v-tab>
          </v-tabs>
          
          <!-- mobile -->
          <v-tabs class="d-sm-none mob" grow vertical v-model="tabs">
            <v-tab>애플리케이션</v-tab>
            <v-tab>보안/네트워크</v-tab>
          </v-tabs>

          <!-- image cashing loading -->
          <img src="@/assets/img_sub_ser_outsourcing01.svg" style="display:none; " />
          <img src="@/assets/img_sub_ser_outsourcing02.svg" style="display:none; " />

          <v-tabs-items v-model="tabs" class="mt-10">
            <v-tab-item>
              <v-sheet width="100%" class="d-flex">
                <img src="@/assets/img_sub_ser_outsourcing01.svg" width="100%" max-width="100%" style="flex:1;" />
              </v-sheet>
              <dl class="mt-6 mt-md-12 text-center">
                <dt class="text-h6 text-md-h5 font-weight-bold mb-2">애플리케이션</dt>
                <dd class="px-4">고객의 Needs에 따른 신규 IT 시스템 개발과 운영 지원.</dd>
              </dl>
            </v-tab-item>
            <v-tab-item>
              <v-sheet width="100%" class="d-flex">
                <img src="@/assets/img_sub_ser_outsourcing02.svg" width="100%" max-width="100%" style="flex:1;" />
              </v-sheet>
              <dl class="mt-6 mt-md-12 text-center">
                <dt class="text-h6 text-md-h5 font-weight-bold mb-2">보안/네트워크</dt>
                <dd class="px-4">고객의 Needs에 따른 신규 IT 시스템 개발과 운영 지원.</dd>
              </dl>
            </v-tab-item>
          </v-tabs-items>
        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'outsourcing',
  data() {
    return {
      tabs: null,
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".outsourcing .sub-body-title", {
      scrollTrigger: {
        trigger: ".outsourcing .sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".outsourcing .sub-body-content", {
      scrollTrigger: {
        trigger: ".outsourcing .sub-body-content",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .3, delay: .3
    });
  },

  methods: {

  }

};
</script>

<style scoped>
</style>